module.exports = __webpack_public_path__ + "static/graph-1_fr-9c828203cb334cbbe04d34919813fe31.svg";